import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {memo, useContext, useEffect, useState} from 'react';

const MAX_SEND = 12;

const BusinessInvoicesResultsSend = () => {
  const [{checked, invoices}, dispatch] = useContext(BusinessInvoicesContext);
  const [invalid, setInvalid] = useState<'accounts' | 'invoices' | false>(false);
  useEffect(() => {
    if (invalid) dispatch({type: 'open-email', invoices: null});
  }, [invalid]);

  useEffect(() => {
    const accounts = new Set(checked?.map((d) => d.accountNumber)).size;
    const selected = checked?.length ?? 0;
    if (accounts > 1) setInvalid('accounts');
    else if (selected > MAX_SEND) setInvalid('invoices');
    else setInvalid(false);
  }, [checked]);

  const total = Math.min(MAX_SEND, invoices?.length ?? 0);

  return checked == null || checked.length == 0 ? null : (
    <div className='BusinessInvoicesResultsSend'>
      <div className='BusinessInvoicesResultsSend__grid'>
        {invalid == 'accounts' && <div className='BusinessInvoicesResultsSend__invalid'>אפשר לבחור חשבוניות מאותו חשבון בלבד</div>}
        {invalid == 'invoices' && <div className='BusinessInvoicesResultsSend__invalid'>אפשר לבחור מקסימום {MAX_SEND} חשבוניות</div>}
        <Image className='BusinessInvoicesResultsSend__icon' src={require('./images/contact-email.svg')} alt='email' />
        <div className='BusinessInvoicesResultsSend__label'>שליחת עותק נאמן למקור</div>
        <div className='BusinessInvoicesResultsSend__checked'>
          <b>{checked.length}</b> / {total}
        </div>
        <button
          className='BusinessInvoicesResultsSend__button'
          onClick={() => dispatch({type: 'open-email', invoices: checked})}
          disabled={!!invalid}>
          שליחה
        </button>
      </div>
    </div>
  );
};
export default memo(BusinessInvoicesResultsSend);
